import { render, staticRenderFns } from "./assessDialog2.vue?vue&type=template&id=4ff06fe2&scoped=true"
import script from "./assessDialog2.vue?vue&type=script&lang=js"
export * from "./assessDialog2.vue?vue&type=script&lang=js"
import style0 from "./assessDialog2.vue?vue&type=style&index=0&id=4ff06fe2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff06fe2",
  null
  
)

export default component.exports